import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".selectPetTypeInfo-library--AOKRa {\n  padding: 0 0 1.6rem;\n  border-bottom: 1px solid #dfdfdf;\n}\n\n.selectPetTypeNote-library--o--CA {\n  margin-top: 1.6rem;\n  border-bottom: 0;\n  padding-bottom: 0;\n  padding: 0;\n}\n\n.selectPetType-library--6zDOe {\n  margin-top: 1.6rem;\n  border-bottom: 0;\n}";
var styles = {"selectPetTypeInfo":"selectPetTypeInfo-library--AOKRa","selectPetTypeNote":"selectPetTypeNote-library--o--CA","selectPetType":"selectPetType-library--6zDOe"};
styleInject(css_248z);

export { styles as default };
